import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
export default {
  computed: {
    globalParameters: get("config/globalParameters")
  },
};
